<th class="record-link-header"></th>

<style lang="less">
    .record-link-header {
        width: 30px;
    }
</style>